import { createSelector } from '@reduxjs/toolkit';
import { getSelectedTeam } from 'TeamsModule/selectors';

export const getSelectedTeamMaxTimerDuration = createSelector(
  getSelectedTeam,
  (selectedTeam) => selectedTeam && selectedTeam.maximum_timer_duration
);
